import {collection, getDocs} from 'firebase/firestore';
import {db} from '../firebase';

import { DestinyLore } from "../globalValues";

export default async function getDestinyWallpapers() {
    try {
        const tempList: DestinyLore[] = [];

        const destinyLore = await getDocs(collection(db, "Destiny-Lore-Wallpapers"));

        destinyLore.forEach(doc => {
            const temp = {
                id: doc.id,
                url: doc.data().url,
                type: doc.data().type,
                season: doc.data().season,
                thumbnail: doc.data().thumbnail
            }
            tempList.push(temp);
        });

        const destinyOther = await getDocs(collection(db, "Destiny-Wallpapers"));

        destinyOther.forEach(doc => {
            const temp = {
                id: doc.id,
                url: doc.data().url,
                type: doc.data().type,
                season: doc.data().season,
                thumbnail: doc.data().thumbnail
            }
            tempList.push(temp);
        });

        tempList.sort(function(a, b) { 
            var textA = parseInt(a.season);
            var textB = parseInt(b.season);
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });
        
        const d = new Date();
        sessionStorage.setItem("listofWallpapers-Destiny", JSON.stringify(tempList));
        localStorage.setItem("Last-Fetch-Time", JSON.stringify(d.getTime()));

        
        return tempList;
    }
    catch(e) {
        console.log(e);
    }    
}

